import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './Attributes.css'

import { Select, NumberSelect } from '../index'

@CSSModules(styles, { allowMultiple: true })
export default class Attributes extends Component {
  static propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.bool
    })),
    disabled: PropTypes.bool,
    onNumberSelectPressed: PropTypes.func,
    onToggleCheckbox: PropTypes.func
  }
  static defaultProps = {
    attributes: []
  }

  _renderSelect (attribute, i) {
    if (attribute.numberSelect) {
      return (
        <div key={`select_${i}`} styleName={`${this.props.disabled ? 'disabled' : ''} attribute`}>
          <NumberSelect
            checked={this.props.disabled ? false : attribute.checked}
            disabled={this.props.disabled}
            name={attribute.name}
            onClick={this.props.onNumberSelectPressed.bind(this, attribute.name)}
            value={attribute.numberSelect.value} />
          <label>
            {attribute.label}
          </label>
        </div>
      )
    }
    else {    
      return (
        <div key={`select_${i}`} styleName={`${this.props.disabled ? 'disabled' : ''} attribute`}>
          <Select
            checked={this.props.disabled ? false : attribute.checked}
            disabled={this.props.disabled}
            name={attribute.name}
            onClick={this.props.onToggleCheckbox.bind(this, attribute.name)} />
          <label>
            {attribute.label}
          </label>
        </div>
      )
    }
  }

  render () {
    return (
      <div styleName="attributes-container">
        <div styleName="row">
          <h2>Tillval<span>{this.props.disabled ? 'Inte tillgängligt för business, välj taxi eller storbil' : ''}</span></h2>
        </div>
        <div styleName="attributes-wrapper">
          {this.props.attributes.map((attribute, i) => this._renderSelect(attribute, i))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/Attributes.js